import { z } from 'zod';
/**
 * Universal search (steps 34–35, PRD VS-070, TechSpec §6.1 `/search`). The API
 * ranks; the web merges these with its local items (pages, cached dashboards
 * and sources) and the viewer's recent picks.
 */
const IsoDate = z.iso.datetime({ offset: true });
export const SEARCH_ITEM_TYPES = ['dashboard', 'source', 'rule', 'alert', 'event'];
export const SearchQuerySchema = z.object({
    q: z.string().trim().min(1).max(200),
    limit: z.coerce.number().int().min(1).max(50).default(20),
});
export const SearchItemSchema = z.object({
    type: z.enum(SEARCH_ITEM_TYPES),
    id: z.string(),
    title: z.string(),
    subtitle: z.string().nullable(),
    /** SPA path the palette navigates to. */
    href: z.string(),
    /** Higher is better; already applied to the order. */
    score: z.number(),
    /** The item's own time (event ts, alert openedAt), when it has one. */
    at: IsoDate.nullable(),
});
export const SearchResponseSchema = z.object({ q: z.string(), items: z.array(SearchItemSchema) });
//# sourceMappingURL=search.js.map